import { render, staticRenderFns } from "./SportelloContrattiIdView.vue?vue&type=template&id=1405b30f&"
import script from "./SportelloContrattiIdView.vue?vue&type=script&lang=ts&"
export * from "./SportelloContrattiIdView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports